import type { Money } from '@/lib/api-admin/types';

/**
 * QA-404(settlement #10) — 작성중 캠페인은 목표 금액 없이 저장할 수 있다. BE 는 미정을 goalAmount.amount === 0 으로 준다
 * (숫자로 올 때도 있다). 미정이면 화면에 "미정"을 쓰고 달성률도 보이지 않는다. 런칭은 BE 가 400 FUNDING_INVALID_GOAL 로 막는다.
 */
export const goalAmountOf = (m: Money | number | null | undefined): number => {
  const n = typeof m === 'number' ? m : m && typeof m === 'object' ? Number(m.amount) : NaN;
  return Number.isFinite(n) ? n : 0;
};

export const isGoalUnset = (m: Money | number | null | undefined): boolean => goalAmountOf(m) <= 0;

export const GOAL_UNSET_LABEL = '미정';
